module.exports = __webpack_public_path__ + "static/media/stock.1803cfc2.jpg";